import Quill from 'quill';
import Vue from 'vue';
import CustomColor from '@groovepages/gd-ui-kit/components/ColorPickerMenu';
import i18n from '../../plugins/i18n';
import CustomBubbleTooltip from './quill-custom-tooltip';
import { QuillToolbarButton } from './quill-toolbar-helper';
import Delta from 'quill-delta';

const Parchment = Quill.import('parchment');
const BlockEmbedHtml = Quill.import('blots/block/embed');
const ImageBlot = Quill.import('formats/image');

const changeToolbarQlFormatsEl = [];
const initializeCustomQuillTooltip = (quill) => {
  const customTooltip = new CustomBubbleTooltip(quill);
  const div = document.createElement('div');
  div.classList.add('ql-toolbar');
  div.classList.add('ql-toolbar-embed');

  customTooltip.root.appendChild(div);

  // Edit Button
  const editButton = new QuillToolbarButton({
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.--><path d="M362.7 19.32c25-24.998 65.6-24.998 90.6 0l39.4 39.43c25 24.99 25 65.55 0 90.55l-48.4 48.4-130-129.98 48.4-48.4zm59 200.98L188.5 453.4c-10.4 10.4-23.3 18.1-37.4 22.2L30.77 511c-8.42 2.5-17.53.2-23.74-6.9-6.21-5.3-8.532-14.4-6.054-22.9L36.37 360.9c4.16-14.1 11.79-27 22.2-37.4L291.7 90.34l130 129.96z"/></svg>`
  });
  editButton.onClick = (quill) => {
    const range = quill.getSelection();
    const content = quill.getContents(range.index, range.length);
    quill.setSelection(range.index, 0, 'silent');
    
    if(content.ops[0].insert.imageElement && content.ops[0].insert.imageElement.value){
      quill.container.parentNode.__vue__.$parent.$refs.editImageModal.open();
    }

    if(content.ops[0].insert.addVideo){
      quill.container.parentNode.__vue__.$parent.$refs.videoPicker.$refs['video-picker-modal'].open();
    }
    
    if(content.ops[0].insert.embedElement){
      quill.container.parentNode.__vue__.$parent.$refs.embedModal.open(); 
      quill.container.parentNode.__vue__.$parent.embedCode = content.ops[0].insert.embedElement.value; 
      quill.container.parentNode.__vue__.$parent.embedEdit = true; 
    }
  };
  editButton.attach(quill, customTooltip);


  const altButton = new QuillToolbarButton({
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"/></svg>`
  });
  changeToolbarQlFormatsEl.push(altButton.qlFormatsEl);

  altButton.onClick = (quill) => {
    const range = quill.getSelection();
    const content = quill.getContents(range.index, range.length);
    quill.setSelection(range.index, 0, 'silent');
    if(content.ops[0].insert.imageElement.value){
      quill.container.parentNode.__vue__.$parent.openAltModal(content.ops[0].insert.imageElement.alt);
    }
  };
  altButton.attach(quill, customTooltip);

  const toolbarButton = new QuillToolbarButton({
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"/></svg>`
  });

  changeToolbarQlFormatsEl.push(toolbarButton.qlFormatsEl);
  
  toolbarButton.onClick = (quill) => {
    const range = quill.getSelection();
    quill.setSelection(range.index, 0, 'user');
    quill.setSelection(range.index, 1, 'user');
  };
  
  // line above
  const addLineAboveButton = new QuillToolbarButton({
    icon: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M5 15h4v6h6v-6h4l-7-8zM4 3h16v2H4z"/></svg>`
  });
  addLineAboveButton.onClick = function(quill) {
      const range = quill.getSelection();         
      quill.insertText(range.index, '\n', true);
      quill.setSelection(range.index, 0);
  };
  addLineAboveButton.attach(quill, customTooltip);

  // line bellow
  const addLineBellowButton = new QuillToolbarButton({
    icon: `<svg style="transform: rotate(180deg)" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M5 15h4v6h6v-6h4l-7-8zM4 3h16v2H4z"/></svg>`
  });
  addLineBellowButton.onClick = function(quill) {
      const range = quill.getSelection();         
      
      const selection = quill.selection.getRange()[1];
      let newRange = 1;
      if(selection.start.node instanceof Image){
        newRange = 2;
      }
      quill.insertText(range.index + 1, '\n', 'user');
      quill.setSelection(range.index + newRange, 0);
  };
  addLineBellowButton.attach(quill, customTooltip);

  // Trash
  const trashButton = new QuillToolbarButton({
    icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.--><path d="M135.2 17.69C140.6 6.848 151.7 0 163.8 0h120.4c12.1 0 23.2 6.848 28.6 17.69L320 32h96c17.7 0 32 14.33 32 32s-14.3 32-32 32H32C14.33 96 0 81.67 0 64s14.33-32 32-32h96l7.2-14.31zM31.1 128H416v320c0 35.3-28.7 64-64 64H95.1c-34.45 0-64-28.7-64-64V128zm80 80v224c0 8.8 8.1 16 16 16 9.7 0 16-7.2 16-16V208c0-8.8-6.3-16-16-16-7.9 0-16 7.2-16 16zm96 0v224c0 8.8 8.1 16 16 16 9.7 0 16.9-7.2 16.9-16V208c0-8.8-7.2-16-16.9-16-7.9 0-16 7.2-16 16zm96.9 0v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16s-16 7.2-16 16z"/></svg>`
  });
  trashButton.onClick = function(quill) {
      const range = quill.getSelection();         
      quill.deleteText(range); 
  };
  toolbarButton.attach(quill, customTooltip);
  trashButton.attach(quill, customTooltip);

  return customTooltip;
};

function trickClickIframe(evt){
  changeToolbarQlFormatsEl.forEach((el) => {
    el.style.display = 'none';
  });
  evt.preventDefault();
  evt.stopPropagation(); 
  evt.stopImmediatePropagation();
  const closestQuillContainer = document.activeElement.closest('.ql-container');
  if(!closestQuillContainer){
    return;
  }
  window.focus();
  const quill = closestQuillContainer.__quill;
  if(!quill){
    return;
  }
  window.setTimeout(() => {
    const range = quill.getSelection();
    let p = Parchment.find(document.activeElement);
    
    if(!p){
      p = Parchment.find(document.activeElement.closest('.video-iframe-wrapper'));
    }
    if (p instanceof BlockEmbedHtml) {
      const off = p.offset(quill.scroll);
      if(!range){
        setTimeout(() => { 
          quill.focus();
        });
      }
      quill.setSelection(off, 0, 'silent');
      quill.setSelection(off, 1, 'silent');
    }
  }, 0);
}

export const vueQuillInit = (quill) => {
  const customTooltip = initializeCustomQuillTooltip(quill);

  window.removeEventListener('blur', trickClickIframe);
  window.addEventListener('blur', trickClickIframe);

  // Click on images
  quill.root.addEventListener('click', (ev) => {
    const range = quill.getSelection();
    if(!range){
      const p = Parchment.find(ev.target);
      if (p instanceof ImageBlot) {
      const off = p.offset(quill.scroll);
      quill.setSelection(off, 1, 'silent');
        return;
      }
    }
    if(!range){
      return;
    }

    if(range.length > 1){
      return;
    }
    
    const image = Parchment.find(ev.target);
    if (image instanceof ImageBlot) {
      changeToolbarQlFormatsEl.forEach((el) => {
        el.style.display = 'block';
      });
      quill.setSelection(image.offset(quill.scroll),0,'user');
      quill.setSelection(image.offset(quill.scroll), 1, 'silent');
    }
  });

  const {tooltip} = quill.theme;  

  tooltip.root.querySelector('.ql-color .ql-picker-options').innerHTML = '<div class="one"></div>';
  tooltip.root.querySelector('.ql-background .ql-picker-options').innerHTML = '<div class="two"></div>';

  // create component constructor
  const cookiesOrigin = null; // PLEASE DEFINE IT TO MAKE THE COOKIES FEATURE WORKS

  const vueColorPicker = Vue.extend(CustomColor);
  let color = quill.getFormat().color || '';
  const vm = new vueColorPicker({
    i18n,
    propsData: {
      value: color,
      immediateChange: true,
      cookiesOrigin: cookiesOrigin
    }
  })
  .$mount('.ql-color .ql-picker-options > div.one')
  .$on('change',(value) => {
    vm.value = value;
  })
  .$on('close-direct',function() {
    tooltip.root.querySelector('span.ql-color.ql-picker.ql-color-picker').classList.remove("ql-expanded");
    tooltip.root.querySelector('span.ql-color.ql-picker.ql-color-picker .ql-picker-label').setAttribute("aria-expanded",false);
    tooltip.root.querySelector('span.ql-color.ql-picker.ql-color-picker .ql-picker-options').setAttribute("aria-expanded",false);
  })
  .$on('push-color',function(color) {
    quill.format('color', color);
  });

  const vueColorPickerBG = Vue.extend(CustomColor);
  let bgColor = quill.getFormat().background || '';
  const vm2 = new vueColorPickerBG({
    i18n,
    propsData: {
      value: bgColor,
      immediateChange: true,
      cookiesOrigin: cookiesOrigin
    }
  })
  .$mount('.ql-background .ql-picker-options > div.two')
  .$on('change',(value) => {
    vm2.value = value;
  })
  .$on('close-direct',function() {
    tooltip.root.querySelector('span.ql-background.ql-picker.ql-color-picker').classList.remove("ql-expanded");
    tooltip.root.querySelector('span.ql-background.ql-picker.ql-color-picker .ql-picker-label').setAttribute("aria-expanded",false);
    tooltip.root.querySelector('span.ql-background.ql-picker.ql-color-picker .ql-picker-options').setAttribute("aria-expanded",false);
  })
  .$on('push-color',function(color) {
    quill.format('background', color);
  });


  // Custom tooltip handle
  quill.on('selection-change', (range, oldRange, source) => {
    customTooltip.hide(); 
    if (!range) return;
    
    const content = quill.getContents(range.index, range.length);
    
    if(range.length == 1 && content.ops[0].insert.embedElement){
      const defaultTooltip = quill.theme.tooltip;
      customTooltip.show();
      defaultTooltip.hide();
    }else{
      customTooltip.hide();
    }

    // Custom color picker
    if( quill.getContents(range.index, range.length).ops[0] && quill.getContents(range.index, range.length).ops[0].attributes && quill.getContents(range.index, range.length).ops[0].attributes.color )
      vm.color = quill.getContents(range.index, range.length).ops[0].attributes.color;
    else
      vm.color = '';

    if( quill.getContents(range.index, range.length).ops[0] && quill.getContents(range.index, range.length).ops[0].attributes && quill.getContents(range.index, range.length).ops[0].attributes.background )
      vm2.color = quill.getContents(range.index, range.length).ops[0].attributes.background;
    else
      vm2.color = '';
  });

  const Inline = Quill.import('blots/inline');
  const Link = Quill.import('formats/link');
  class ExternalLink extends Inline {
    static create(value) {
      const node = Link.create(value);
      value = Link.sanitize(value);

      node.setAttribute('target','_blank');
      node.setAttribute('href', value);
      node.classList.add('gdel54');
      return node;
    };

    static formats(domNode) {
      return domNode.getAttribute('href');
    }
  }

  ExternalLink.blotName = 'external_link';
  ExternalLink.className = 'gdel54';
  ExternalLink.tagName = 'A';

  class InternalLink extends Inline {
    static create(value) {
      const node = Link.create(value);
      value = Link.sanitize(value);

      node.setAttribute('target','_self');
      node.setAttribute('href', value);
      node.classList.add('gdil54');
      return node;
    };

    static formats(domNode) {
      return domNode.getAttribute('href');
    }
  }

  InternalLink.blotName = 'internal_link';
  InternalLink.className = 'gdil54';
  InternalLink.tagName = 'A';

  Quill.register({
    'formats/internal_link': InternalLink,
    'formats/external_link': ExternalLink
  });
  const input = tooltip.root.querySelector('input[data-link]');
  input.dataset.link = 'https://groove.cm';
  const openNewTabButton = document.createElement("div");
  const saveButton = document.createElement("button");
  openNewTabButton.innerHTML = `<label class="switch"><input type="checkbox"><span class="slider round"></span></label><p class="flex-1">${i18n.t('frontend_grooveblog_new_tab')}</p>`;
  saveButton.innerHTML = i18n.t('frontend_grooveblog_save');

  const inputButton = openNewTabButton.getElementsByTagName('input');
  
  openNewTabButton.addEventListener("click", (e) => {
    e.stopPropagation();
    e.preventDefault();
    if(!(inputButton[0].hasAttribute('checked')))
      inputButton[0].setAttribute('checked','');
    else
      inputButton[0].removeAttribute('checked');
  });

  saveButton.addEventListener("click", () => {
    if(input.value){
      if(inputButton[0].hasAttribute('checked')){
        quill.format('external_link', input.value); // Blank
      }else{
        quill.format('internal_link', input.value); // Self
      }

      inputButton[0].removeAttribute('checked');
      input.value = '';
    }
  });

  // Insert After Element
  input.after(openNewTabButton);
  openNewTabButton.after(saveButton);

  // Clipboard settings for copy-paste
  let brTagsCount = 0;

  quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
    const plaintext = node.innerText;
    if (delta.ops.length === 0) {
      return new Delta();
    }

    if (
        typeof delta.ops[0].insert.addVideo !== 'undefined' &&
        delta.ops[0].insert.addVideo.shortId === ''
    ) {
      if (
        delta.ops[0].insert.addVideo.videoEmbed === '<br>' &&
        brTagsCount < 2
      ) {
        brTagsCount += 1;
        return new Delta();
      }
      brTagsCount = 0;
      return new Delta()
      .insert(
        plaintext.includes('\n')
        ? plaintext
        : `${plaintext}\n`
        );
      }

    return delta;
  });

};
export const theBlockBlot = (quill, vueInst) =>{
  setTimeout(() => {
    const Block = Quill.import('blots/block');
    const range = quill.getSelection(true);
    if (range == null) return;
    if (range.length == 0) {
      const [block, offset] = quill.scroll.descendant(Block, range.index);
      if (
        block != null &&
        block.domNode.innerText.trim().length === 0
      ) {
        vueInst.showToolbar = true;
        const lineBounds = quill.getBounds(range);
        vueInst.topPosition = lineBounds.top - 5;
      } else {
        vueInst.showToolbar = false;
      }
    }
  }, 300);
};

export const quillToolbar = [
	[{ header: [1, 2, 3, 4, 5, 6, false] }],
	['bold', 'italic', 'underline', 'strike'],
	[{ list: 'ordered' }, { list: 'bullet' }],
	[{ color: [] }, { background: [] }],
	[{ align: [] }],
	['link'],
];
